<template>
  <stihl-modal class="modal" @modal-closed="$emit('cancel')">

    <div class="title-row">
      <h3 class="title">{{ title }}</h3>
    </div>

    <slot />

    <div class="buttons">
      <button type="button" class="btn btn-default" data-bs-dismiss="modal" data-testid="cancel-button">
        {{ cancel ?? defaultCancelLabel }}
      </button>
      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
              data-testid="confirm-button"
              :disabled="disabledConfirm"
              @click="$emit('confirm', true)">
        {{ confirm ?? defaultConfirmLabel }}
      </button>
    </div>

  </stihl-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import StihlModal from '@/components/ui/StihlModal.vue';

export default defineComponent({
  name: 'ConfirmationModal',
  components: { StihlModal },
  emits: ['cancel', 'confirm'],
  props: {
    title: { type: String, required: true },
    cancel: { type: String, default: null },
    confirm: { type: String, default: null },
    disabledConfirm: { type: Boolean, default: false },
  },
  computed: {
    defaultCancelLabel() {
      return this.$t('dss.button.cancel');
    },
    defaultConfirmLabel() {
      return this.$t('dss.button.continue');
    },
  },
});
</script>

<style>
</style>
